import { render, staticRenderFns } from "./ModalApproveRequest.vue?vue&type=template&id=76d70c8c&"
import script from "./ModalApproveRequest.vue?vue&type=script&lang=js&"
export * from "./ModalApproveRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports